import { Injectable } from '@angular/core';

@Injectable()
export class StuDataService {
  stuObj:any;
  constructor() { 
    this.stuObj = [{
      name: 'Himalaya Pagada',
      designation: 'Sr. Web Interface Designer'
    },
    {
      name: 'Bibhudatta Sir',
      designation: 'Sr. Web Interface Designer'
    },
    {
      name: 'Biraja Guru',
      designation: 'Sr. Software Developer'
    }
  ]
  }

  getData() {
    return this.stuObj;
  }
  setData(newData) {
    this.stuObj.push(newData);
  }

}
